import { Component, ChangeDetectionStrategy, Input, Output, EventEmitter } from '@angular/core';
import { Store } from '@ngrx/store';
import { BcConfigService } from 'common/config/provider';
import { uploadAttachment } from 'common/store/genesys-cloud/conversations/emails/actions/email-message.actions';

@Component({
  selector: 'app-genesys-email-attachment-button',
  templateUrl: './genesys-email-attachment-button.component.html',
  styleUrls: ['./genesys-email-attachment-button.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class GenesysEmailAttachmentButtonComponent {
  selectedFile: File;
  @Input() conversationId: string;
  @Input() disabled: boolean;
  @Output() sizeLimitError = new EventEmitter();

  constructor(private readonly store: Store, private readonly _config: BcConfigService) {}

  uploadFile(): void {
    if (this._isFileInSizeLimit()) {
      this._dispatchAttachmentUpload();
    }
  }

  resetFilePath(event: Event): void {
    (event.target as HTMLButtonElement).value = null;
  }

  private _isFileInSizeLimit(): boolean {
    const unit = 1024;
    const fileSize = parseInt((this.selectedFile.size / unit).toString(), 10);

    if (fileSize > this._config.current.genesysFileUploadSizeLimit) {
      const sizeLimit = this._config.current.genesysFileUploadSizeLimit / unit;
      this.sizeLimitError.emit(sizeLimit);

      return false;
    }

    return true;
  }

  private _dispatchAttachmentUpload(): void {
    const form = new FormData();
    form.append('conversationId', this.conversationId);
    form.append('file', this.selectedFile);
    this.store.dispatch(uploadAttachment({ conversationId: this.conversationId, form }));
  }
}
